/*
 * Copyright (c) 2026 Macrofocus GmbH. All Rights Reserved.
 */
package com.macrofocus.high_d.parallelcoordinates

import org.mkui.canvas.CPCanvas
import org.mkui.color.MkColor
import org.mkui.color.colorOf
import org.mkui.geom.Point2D
import org.mkui.geom.Rectangle
import org.mkui.geom.Rectangle2D
import org.mkui.graphics.AbstractIDrawing
import org.mkui.graphics.IGraphics

/** A tooltip of the parallel coordinates view: a line of text in a light yellow box, as a JToolTip. */
class TooltipView : CPCanvas() {
    var text: String = ""
        set(value) {
            if (field != value) {
                field = value
                drawing.changed()
            }
        }

    private val drawing = object : AbstractIDrawing() {
        override fun draw(g: IGraphics, point: Point2D?, width: Double, height: Double, clipBounds: Rectangle) {
            if (text.isEmpty() || width <= 0 || height <= 0) {
                return
            }
            g.setColor(BACKGROUND)
            g.fillRectangle(0, 0, width.toInt(), height.toInt())
            g.setColor(BORDER)
            g.setLineWidth(1.0)
            g.drawShape(Rectangle2D.Double(0.5, 0.5, width - 1, height - 1))
            g.setFont(AxisHeaderView.FONT)
            g.setColor(TEXT)
            g.setTextBaseline(IGraphics.TextBaseline.Middle)
            g.drawString(AxisHeaderView.elide(g, text, width - 2 * PADDING), PADDING.toFloat(), (height / 2).toFloat())
        }

        fun changed() {
            notifyIDrawingChanged()
        }
    }

    init {
        addLayer(drawing)
    }

    companion object {
        const val PADDING = 4.0
        const val HEIGHT = 20.0

        /** Delay before the tooltip is shown, in milliseconds. */
        const val DELAY = 750

        private val BACKGROUND: MkColor = colorOf(255, 255, 225)
        private val BORDER: MkColor = colorOf(128, 128, 128)
        private val TEXT: MkColor = colorOf(0, 0, 0)
    }
}
